// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"9cfce358","635":"a1b69244"}[chunkId] + ".chunk.js";
};